/** The request path builder for querying for a customer for a set of known contact details. */
export const getCustomerSearchPath = (contactId: string, customerId: string) =>
  `Legacy/V2/contacts/${contactId}/customers/${customerId}`;
